module.exports = __webpack_public_path__ + "static/media/book4_2.22076219.jpg";